import { addDays, endOfDay } from 'date-fns';
import React, { useMemo } from 'react';
import { LifeAreaInsightsCard } from 'shared/components/connected/life-area-insights-card';
import { useToday } from 'shared/contexts/today';
import { MetricEntry, MetricEntryMode } from 'shared/types/goal-metric';
import { LifeArea } from 'shared/types/life-area';
import { v4 as uuidv4 } from 'uuid';

const target = 10;
const average = 2;
const currentValue = 7;

export type LifescanInsightsPreviewCardProps = {
  lifeArea: LifeArea;
};

export const LifescanInsightsPreviewCard: React.FC<
  LifescanInsightsPreviewCardProps
> = ({ lifeArea }) => {
  const today = useToday();

  const entries = useMemo<MetricEntry[]>(
    () => [
      {
        id: uuidv4(),
        date: addDays(today, -7),
        value: 5,
        mode: MetricEntryMode.Absolute,
      },
      {
        id: uuidv4(),
        date: addDays(today, -5),
        value: 3,
        mode: MetricEntryMode.Absolute,
      },
      {
        id: uuidv4(),
        date: addDays(today, -2),
        value: 10,
        mode: MetricEntryMode.Absolute,
      },
      {
        id: uuidv4(),
        date: today,
        value: currentValue,
        mode: MetricEntryMode.Absolute,
      },
    ],
    [today],
  );

  const startDate = addDays(today, -7);
  const endDate = endOfDay(today);

  return (
    <LifeAreaInsightsCard
      lifeArea={lifeArea}
      entries={entries}
      startDate={startDate}
      endDate={endDate}
      currentValue={currentValue}
      target={target}
      average={average}
      isPreview
    />
  );
};
